/* eslint-disable no-console */

import {
  register
} from 'register-service-worker'

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Do not reload a first-time visitor. Reload existing clients once when a
    // newly deployed service worker takes control.
    if (!hadController || refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    scope: '/',
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      console.log('Service worker has been registered.')

      // Registration normally checks on navigation. Also check periodically so
      // a portal tab left open for days still receives new deployments.
      setInterval(() => registration.update(), 15 * 60 * 1000);
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available and will be loaded automatically.')
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
